import { render } from "./CGV.vue?vue&type=template&id=70840fa0"
import script from "./CGV.vue?vue&type=script&lang=js"
export * from "./CGV.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2009374271/src/sayuri/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__